import { getCadeteColor } from "./colors";
import { getTrackingTimestamp } from "./time";

const toNumber = (value) => {
    if (value === undefined || value === null || value === "") return null;
    const parsed = Number(value);
    return Number.isNaN(parsed) ? null : parsed;
};

export const normalizeLocation = (location = {}) => {
    const lat = toNumber(location.lat ?? location.latitud ?? location.latitude);
    const long = toNumber(location.long ?? location.lng ?? location.longitud ?? location.lon);

    if (lat === null || long === null) return null;
    return { lat, long };
};

export const normalizeCity = (city) => {
    if (!city) return null;

    const latitud = toNumber(city.latitud ?? city.lat ?? city.latitude);
    const longitud = toNumber(city.longitud ?? city.long ?? city.lng ?? city.lon);

    return { ...city, latitud, longitud };
};

export const normalizeTrackingData = (cadetes = []) => {
    return cadetes.map((cadete) => ({
        ...cadete,
        color: getCadeteColor(cadete.id),
        location: normalizeLocation(cadete.location || {}),
        pedidos: Array.isArray(cadete.pedidos)
            ? cadete.pedidos.map((pedido) => ({
                ...pedido,
                origen: normalizeLocation(pedido.origen || {}) || pedido.origen,
                destino: normalizeLocation(pedido.destino || {}) || pedido.destino
            }))
            : [],
        lastTrackingAt: getTrackingTimestamp(cadete)
    }));
};

const getTimeValue = (date) => {
    if (!date) return 0;
    const parsed = new Date(date);
    return Number.isNaN(parsed.getTime()) ? 0 : parsed.getTime();
};

export const orderCadetesByLastTracking = (cadetes = []) => {
    const cadetesCopy = [...cadetes];
    cadetesCopy.sort((a, b) => getTimeValue(b.lastTrackingAt) - getTimeValue(a.lastTrackingAt));
    return cadetesCopy;
};
